module.exports = __webpack_public_path__ + "img/loading.40ec8982.gif";